const PARTICLES = new Set(["di", "del", "della", "dei", "degli", "delle", "da", "de", "d'", "e", "ed", "in", "la", "le", "lo", "il", "i", "gli", "al", "alla", "allo", "ai", "agli", "alle", "sul", "sulla", "su", "a", "von", "van", "der", "des", "du", "y"]);

export const titleCase = (value = "") =>
  value
    .replace(/\s+/g, " ")
    .split(" ")
    .map((word, i) => {
      if (!word) return word;
      const lower = word.toLowerCase();
      if (i > 0 && PARTICLES.has(lower)) return lower;
      if (/^\d/.test(word)) return word;
      return lower.split(/(['-])/).map(part => (part === "'" || part === "-") ? part : part.charAt(0).toUpperCase() + part.slice(1)).join("");
    })
    .join(" ");

const DELIVERY_KEY = "delivery_info";
const BUYER_KEY = "fl_buyer_info";

export const saveDeliveryInfo = (info) => {
  sessionStorage.setItem(DELIVERY_KEY, JSON.stringify(info));
  localStorage.removeItem(DELIVERY_KEY);
  sessionStorage.removeItem("fl_context_shop");
  window.dispatchEvent(new Event("fl-delivery-changed"));
};

export const loadDeliveryInfo = () => {
  try {
    return JSON.parse(sessionStorage.getItem(DELIVERY_KEY) || "null");
  } catch { return null; }
};

export const clearDeliveryInfo = () => {
  sessionStorage.removeItem(DELIVERY_KEY);
  localStorage.removeItem(DELIVERY_KEY);
};

export const saveBuyerInfo = (data) => sessionStorage.setItem(BUYER_KEY, JSON.stringify(data));
export const loadBuyerInfo = () => {
  try { return JSON.parse(sessionStorage.getItem(BUYER_KEY) || "null"); } catch { return null; }
};
export const clearBuyerInfo = () => { sessionStorage.removeItem(BUYER_KEY); localStorage.removeItem(BUYER_KEY); };

const RECIPIENT_KEY = "fl_recipient_info";
export const saveRecipientInfo = (data) => sessionStorage.setItem(RECIPIENT_KEY, JSON.stringify(data));
export const loadRecipientInfo = () => {
  try { return JSON.parse(sessionStorage.getItem(RECIPIENT_KEY) || "null"); } catch { return null; }
};
export const clearRecipientInfo = () => localStorage.removeItem(RECIPIENT_KEY);

const DRAFT_KEY = "fl_checkout_draft";
export const saveCheckoutDraft = (draft) => sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
export const loadCheckoutDraft = () => {
  try { return JSON.parse(sessionStorage.getItem(DRAFT_KEY)) || null; } catch { return null; }
};
export const clearCheckoutDraft = () => sessionStorage.removeItem(DRAFT_KEY);
